import React from "react";

import edit_email from "./edit_email.png";

const EditEmailTemplates = () => (
  <div id={"customisable_edit_resources"} className={"section"}>
    <h2>5.3 Edit Email Templates</h2>
    <p>
      Each time an email is sent, it will use the settings stored in its corresponding email
      template.
    </p>
    <p>
      The <strong>welcomeemail</strong> template, for example, is used when you opt to send an email
      to a user when adding them to a portal.
    </p>
    <img src={edit_email} alt={"Edit Email Template"} className={"center"} />
  </div>
);

export default EditEmailTemplates;
